/**
 * ****************************************************************************
 * @description     :   All types will be process on page reports
 * @created at      :   2022/07/18
 * @created by      :   QuanHVM
 * @package         :   report-daily-react
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * All types will be process on page reports
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/18 - create
 * @access : public
 */
const Types = {
    // Get list reports
    /**
     * Type to get data of reports
     */
    FETCHING_REPORTS: 'FETCHING_REPORTS',
    
    // Get list reports
    /**
     * Type to change data of reports when get data success
     */
    FETCHING_REPORTS_SUCCESS: 'FETCHING_REPORTS_SUCCESS',
     
    // Get list reports
    /**
     * Type to reset data of reports when get data failure
     */
    FETCHING_REPORTS_FAILURE: 'FETCHING_REPORTS_FAILURE',

    // Change data checkbox
    /**
     * Set data checkbox of reports when event change input checkbox
     */
    CHECKBOX_REPORT: 'CHECKBOX_REPORT',

    // destroy data
    /**
     * Remove data have checkbox when event remove
     */
    DESTROY_REPORTS: 'DESTROY_REPORTS',

    // Init data report detail
    /**
     * Init data report detail when load page
     */
    SHOW_DATA_REPORT_INIT: 'SHOW_DATA_REPORT_INIT',

    // Get data report detail
    /**
     * Type to reset data of report detail when get data success
     */
    FETCHING_REPORT_DETAIL_SUCCESS: 'FETCHING_REPORT_DETAIL_SUCCESS',

    // Get data report detail
    /**
     * Type to reset data of report detail when get data failure
     */
    FETCHING_REPORT_DETAIL_FAILURE: 'FETCHING_REPORT_DETAIL_FAILURE',

    // insert data report
    /**
     * Type to add new data of report detail
     */
    ADD_REPORT: 'ADD_REPORT',

    // varible show popup data report
    /**
     * Type to show popup data report when event open popup
     */
    IS_SHOW_POPUP_REPORT_DETAIL: 'IS_SHOW_POPUP_REPORT_DETAIL',

    
    // varible show popup data report
    /**
     * Type to show popup data report when event open popup
     */
    CLEAR_STORAGE: 'CLEAR_STORAGE'
}

export default Types;